const shouldIgnoreEntity = (data) => {
  return data?.["x-internal"] === true || data?.["x-scalar-ignore"] === true;
};
export {
  shouldIgnoreEntity
};
//# sourceMappingURL=should-ignore-entity.js.map
